<div class="lba-action-menu">
  <button type="button" class="lba-action-menu__trigger" [disabled]="disabled"
    [attr.aria-expanded]="isOpen" aria-haspopup="menu" (click)="toggle($event)">
    <ng-content></ng-content>
  </button>

  <div *ngIf="isOpen" class="lba-action-menu__panel" role="menu"
    [style.min-width.px]="panelMinWidth"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <button type="button" class="lba-action-menu__item"
      *ngFor="let item of items; trackBy: trackByItemId" role="menuitem"
      [disabled]="!!item.disabled" (click)="onItemClick(item, $event)">
      <i *ngIf="item.icon" class="lba-action-menu__item-icon" [ngClass]="item.icon"></i>
      <span class="lba-action-menu__item-text">{{ item.text }}</span>
    </button>
    <div *ngIf="items.length === 0" class="lba-action-menu__empty">No actions</div>
  </div>
</div>
